import React from "react";
import { Card, CardContent, Checkbox, Typography, Grid, Box, FormControlLabel } from "@mui/material";
import diseño from "../../../../Image/Frame 0.png"
import diseño1 from "../../../../Image/Frame 2.png"
import diseño2 from "../../../../Image/Frame 3.png"
import diseño3 from "../../../../Image/Frame 4.png"
import diseño4 from "../../../../Image/Frame 5.png"

const diseños = [
  { id: 1, imagen: diseño, nombre: "Diseño 1" },
  { id: 2, imagen: diseño1, nombre: "Diseño 2" },
  { id: 3, imagen: diseño2, nombre: "Diseño 3" },
  { id: 4, imagen: diseño3, nombre: "Diseño 4" },
  { id: 5, imagen: diseño4, nombre: "Diseño 5" },
];
export const SeleccionDiseño = ({ onSeleccionarDiseño, diseñoSeleccionado }) => {

  return (
    <Box sx={{ flexGrow: 1, p: 2 }}>
      <Typography variant="h5" gutterBottom>
        Selecciona un diseño
      </Typography>
      <Grid container spacing={2}>
        {diseños.map((diseño) => (
          <Grid item xs={12} sm={6} md={4} key={diseño.id}>
            <Card
              variant="outlined"
              sx={{ padding: 2, borderColor: diseñoSeleccionado === diseño.id ? 'primary.main' : 'grey.300' }}
              onClick={() => onSeleccionarDiseño(diseño.id)}
            >
              <CardContent>
                <img src={diseño.imagen} alt={diseño.nombre} style={{ width: '100%', borderRadius: '8px' }} />
                <Typography variant="h6" mt={1}>{diseño.nombre}</Typography>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={diseñoSeleccionado === diseño.id}
                      onChange={() => onSeleccionarDiseño(diseño.id)}
                      color="primary"
                    />
                  }
                  label="Seleccionar"
                />
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}